export default "__VITE_ASSET__8598c8ef__"